
import { defineComponent, PropType, shallowRef } from 'vue'
import { useClipboard } from '@vueuse/core'
import { Message as ElMessage } from 'element-ui'

import { IFileRead } from '@/api/nlp/nlp-api-type'
import NlpCard from '@/views/NLP/components/NlpCard.vue'

export default defineComponent({
  components: { NlpCard },
  props: {
    themeWords: {
      type: Array as PropType<IFileRead.ThemewordListItem[]>,
      required: true
    },
    params: {
      type: Object as PropType<Pick<IFileRead.ThemeWordReqParams, 'keywordCount'>>,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update-theme-word-count'],
  setup (props, { emit }) {
    const countOptions = [10, 20, 30, 40, 50, 100]
    function countChange (count: number) {
      emit('update-theme-word-count', count)
    }

    const selectedRow = shallowRef<IFileRead.ThemewordListItem[]>([])
    const { copy } = useClipboard({ legacy: true })

    function copyTextFunc (str: string) {
      copy(str)
      ElMessage.success('复制成功')
    }

    return {
      copyTextFunc,
      countOptions,
      countChange,
      selectedRow,
      copy,
    }
  },
})
